import React, { Component } from 'react';
import FormClient from '../sales/FormClient';
import FormQuote from './FormQuote';
import Select from 'react-select'

import { isEmpty } from 'lodash';
import PopUp from '../../../../commonModules/interface/PopUp';
import { TableRow, TableCell, Button, TableBody, IconButton } from '@material-ui/core';
import InputText, { InputSelect, InputSelectMagasin } from '../../../../commonModules/interface/form-input-inline';
import { TableLayout } from '../containers/Layout';
import { CloseRounded } from '@material-ui/icons';
import { initClient, initErrors, initQuote } from '../StockFormsStruct';
import ProductLineCell from '../containers/ProductLineCell';
import { toast } from 'react-toastify';
import { generateUniqueId } from '../../../../commonModules/utils/statsFunctions';
import ConfirmFormTemplate from '../transfers/Forms/ConfirmFormTemplate';


class Form extends Component {
    state = { 
        sale:Object.assign({},initQuote),
        errors:Object.assign({},initErrors),
        client:Object.assign({},initClient),
        errorsClient:Object.assign({},initClient),
        view: "quote",
        numberProd:1,
        sending: false,
        uniqueID: generateUniqueId(),
        form: <div></div>
    }
    
    handleSelect = (option, name) => {
        console.log("SELECT HANDLE handleSelect",{option, name});

        let value = option.value
        let displayName = name +'Display'
        if(name === "nature"){
            console.log("change nature");
            
            this.setState({
                ...this.state,
                sale:{
                    ...this.state.sale,
                    transport:0,
                    taxes:0,
                    [name]:value,
                    [displayName]:option
                }
            })
        } else if(name === "shop_id"){
            console.log("change shop_id");
            
            this.setState({
                ...this.state,
                sale:{
                    ...this.state.sale,
                    [name]:value,
                    [displayName]:option,
                    products:[ // reset products array to prevent stock errors
                        {
                            display:{value:"", label:""},
                            product_id:"",
                            quantity:"",
                            max:"",
                            stock_id:"",
                            price:"",
                            priceUReal:"",
                            priceTotal:"",
                        }
                    ],
                },
                numberProd:1
            },  () =>{
                this.createAddForm()
            })
        } else {
            this.setState({
                ...this.state,
                sale:{
                    ...this.state.sale,
                    [name]:value,
                    [displayName]:option
                }
            })
        }        
    }
    handleSelectProducts = (option, index) => {
        console.log("SELECT HANDLE handleSelectProducts",{option, index});

        let value = option.value
        const shop_id = this.state.sale.shop_id
        const max = this.findMax(value, shop_id)    

        let cpProducts = this.state.sale.products
        cpProducts[index].product_id = value
        cpProducts[index].max = max.max
        cpProducts[index].stock_id = max.stock_id
        cpProducts[index].price = max.price
        cpProducts[index].priceUReal = max.price
        cpProducts[index].priceU = max.priceU
        cpProducts[index].prod_tva_rate = max.tva
        cpProducts[index].priceTotal = (max.price * (cpProducts[index].quantity || 0) )
        cpProducts[index].display = option
        
        this.setState({
            ...this.state,
            sale:{
                ...this.state.sale,
                products:cpProducts,
            }
        }, () =>{
            this.createAddForm()
        })       
    }

    findMax = (product_id, shop_id, list = this.props.AVAILABLE)=> { // return available stock and it's id
        const { PRODUCTS } = this.props
        let max = 0
        let stock_id = ""
        let price = 0
        let priceU = 0
        let tva = 0

        Object.keys(list).map((ID) => {            
            if(list[ID].product_id === product_id ){// && list[ID].shop_id === shop_id ){    
                // console.log("INFO find max", product_id, shop_id, stock.quantity, stock, stock.stock, stock.product.prix_venteTTC);
                max = list[ID].quantity
                stock_id = ID
                tva = PRODUCTS[list[ID].product_id].tva_rate || 0
                price = PRODUCTS[list[ID].product_id].prix_venteTTC.toFixed(2)
                priceU = PRODUCTS[list[ID].product_id].prix_venteHT.toFixed(2)

                if (price % 1 === 0 ) {
                    PRODUCTS[list[ID].product_id].prix_venteTTC.toFixed(0)
                }
                if (priceU % 1 === 0 ) {
                    PRODUCTS[list[ID].product_id].prix_venteTTC.toFixed(0)
                }
                return                    
            }
        })   
        // console.log("findMax", max,);
        return {
            max, 
            stock_id, 
            price, 
            priceU, 
            tva
        }
    }

    createProductList = () => {
        console.log("DEBUG,createProductList,quote",this.state.sale)
        const { sale } = this.state;
        const list = [{value:"", label:"Chosissez un Produit"}]
        const  { AVAILABLE, PRODUCTS } = this.props
        if(PRODUCTS){
            let selectedProds = sale.products.map( prod => prod.product_id)
            Object.values(PRODUCTS).map(prod => {   
                let selected = selectedProds.includes(prod.id)
                list.push (       
                    {value:prod.id, 
                    label: `${prod.marque} - ${prod.name} — ${prod.ref}`, 
                    disabled:selected
                })
            })
        }
        return list
    }
    createAddForm = () => {
        const tab = []
        const products = this.createProductList()


        console.log("[INFO],createAddForm,Form, CREATE ADD FORM INDEX ",this.state.numberProd);
        for (let i = 0; i < this.state.numberProd;i++) {
            
            tab.push(
                <TableRow key={i} >             
                    {/* <TableCell>
                        {this.state.numberProd > 1 &&
                        <IconButton type="button" className="delete-line" onClick={()=> this.handleDeleteProd(i)}>
                            <CloseRounded />
                        </IconButton>
                        }
                        <InputSelectMagasin
                            options={products}
                            value={this.state.sale.products[i].display}
                            label="Produit"
                            placeholder="Selectioner un Produit"
                            onChange={option => this.handleSelectProducts(option,i)}
                            error={this.state.errors.products[i].product_id}
                        />    
                    </TableCell> */}
                    <ProductLineCell
                        numberProd={this.state.numberProd}
                        handleDeleteProd={() => this.handleDeleteProd(i)}
                        options={products}
                        value={this.state.sale.products[i].display}
                        onChange={option => this.handleSelectProducts(option,i)}
                        error={this.state.errors.products[i].product_id}
                        PRODUCTS={this.props.PRODUCTS}
                    />
                    <TableCell className="text-center" style={{width: "150px"}}>
                        <InputText 
                            type="number" 
                            min={1} 
                            max={this.state.sale.products[i].max} 
                            step={10} 
                            className="form-control input-sm" 
                            onChange={this.handleChange} 
                            value={this.state.sale.products[i].quantity} 
                            name={"prod_-quantity-"+i} 
                            title="Quantité"
                            error={this.state.errors.products[i].quantity}
                            helperText={this.state.sale.products[i].max ? "Disponible : "+ this.state.sale.products[i].max :"" }
                        />
                    </TableCell>
                    <TableCell>
                        <InputText 
                            disabled
                            type="number" 
                            className="form-control input-sm" 
                            onChange={this.handleChange} 
                            value={this.state.sale.products[i].price} 
                            name={"prod_-price-"+i} 
                            title="Prix"
                            error={this.state.errors.products[i].price}
                            helperText={this.state.sale.products[i].priceUReal ? "Prix Unitaire Base: "+ this.state.sale.products[i].priceUReal :"" }
                        />
                    </TableCell>
                    <TableCell >
                        <InputText 
                            type="number" 
                            className="form-control input-sm" 
                            onChange={this.handleChange} 
                            value={this.state.sale.products[i].priceTotal } 
                            name={"prod_-priceTotal-"+i} 
                            placeholder="Prix Total"
                            error={this.state.errors.products[i].priceTotal}
                            helperText={(this.state.sale.products[i].priceUReal && this.state.sale.products[i].quantity) ? "Prix Total Base : "+ 
                            (this.state.sale.products[i].priceUReal * this.state.sale.products[i].quantity ).toFixed(2) :"" }
                        />
                    </TableCell>
                </TableRow>                                        
            )
        }
        this.setState({
            ...this.state,
            form:tab,
        })
        return tab;
    }
    handleAddProd = () => {// must add new line in the form to add a product to the sale
        console.log("Form Sales ,handleAddProd,")
        const shop_id = this.state.sale.shop_id
        if (shop_id === ""){
            toast.error("Shop must be selected")
            return
        }
        this.setState({
            ...this.state,
            sale:{
                ...this.state.sale,
                products:[
                    ...this.state.sale.products,{
                    display:{},
                    product_id:"",
                    quantity:"",
                    max:"",
                    stock_id:"",
                    price:"",
                    priceUReal:"",
                    priceTotal:"",
                    //priceHT:"",
                    prod_tva_rate: "",
                }]
            },
            errors:{
                ...this.state.errors,
                products:[
                    ...this.state.errors.products,{                      
                    product_id:"",
                    quantity:"",
                    priceUReal:"",
                    priceTotal:"",
                    
                }]
            },
            numberProd:this.state.numberProd+1,
        }, () => {
            // Code à exécuter une fois que setState est terminé
            console.log('setState a été finalisé.');
            this.createAddForm()
        });
    }
    handleAddProdByCSV = (productList) =>{
        console.log("Form Sales ,handleAddProdByCSV,",productList)
        const productListLocal = new Array();
        const productListLocalErr = new Array();
        const shop_id = this.state.sale.shop_id
        if (shop_id === ""){
            toast.error("Shop must be selected")
            return
        }
        var total = 0 
        let discount = 0;
        let nbOfProduct = 0;

        productList.forEach((value, key)=>{
            console.log("Form Sales ,handleAddProdByCSV,",value[5],value[4])
            if (!value[4]){
                return
            }
            const max = this.findMax(value[5].id, shop_id)    
            if (max.stock_id ===""){
                toast.error( "Produit '"+ value[5].name+ "' pas disponible dans le magasin")
                return
            }
            nbOfProduct++

            const price = (value[3] / value[2]).toFixed(2) || max.price
            const priceU = (max.price / ( 1 + max.tva / 100)).toFixed(2)

            const productEntry = {
                display: {value:value[5].id,label:value[0]},
                product_id: value[5].id,
                quantity: value[2],
                max: max.max,
                stock_id: max.stock_id,
                price: price,
                priceUReal: max.price,
                priceU: priceU, 
                priceTotal: value[3],
                //priceHT: "",
                prod_tva_rate: max.tva,
              };
            const productEntryErr = {                      
                product_id:"",
                quantity:"",
                priceUReal:"",
                priceTotal:"",
                
            };
            productListLocal.push(productEntry);
            productListLocalErr.push(productEntryErr);
            total += parseFloat(value[3])
            let addDiscount = ((max.priceU * value[2] ) - value[3]).toFixed(2)
            discount += addDiscount > 0 ? addDiscount : 0
         
        })
        console.log("Form Sales ,handleAddProdByCSV,productListLocal",productListLocal)
        if (productListLocal.length > 0){
            console.log("Form Sales ,handleAddProdByCSV,Add product",productListLocal.length)
            this.setState({
                ...this.state,
                sale:{
                    ...this.state.sale,
                    products:[
                        ...productListLocal],
                    total,
                    discount
                },
                errors:{
                    ...this.state.errors,
                    products:[
                        ...productListLocalErr]
                },
                numberProd:nbOfProduct,
            }, () =>{
                this.createAddForm()
            })  
        }
        toast.info( "Importation réussi de "+nbOfProduct+" produits")
    }
    
    handleDeleteProd = (index) => {
        let cpProducts = [].concat(this.state.sale.products)
        let cpErrors = [].concat(this.state.errors.products)
        let total = 0;

        cpProducts = [
            ...cpProducts.slice(0,index),
            ...cpProducts.slice(index +1),
        ]
        cpErrors = [
            ...cpErrors.slice(0,index),
            ...cpErrors.slice(index +1),
        ]
        cpProducts.map( prod => {
            if ( prod.priceUReal && prod.quantity && prod.priceTotal){
                total += parseFloat(prod.priceTotal)
            }
        }) 
        this.setState({
            ...this.state,
            sale:{
                ...this.state.sale,
                products: cpProducts,
                total
            },
            errors:{
                ...this.state.errors,
                products: cpErrors
            },
            numberProd: this.state.numberProd - 1,
        }, () =>{
            this.createAddForm()
        })  
    }
    handleChange = (e) => {  
        const field = e.target.name
        const value = e.target.value
        // const regex = /^[0-9\b]+$/ // int only
        // const regex = /^\d+$/; // positive int only
        const regexINT = /^\d+$/;
        const regexFLOAT = /^\d+(\.\d+)?$/;
        if(field.startsWith("prod_")){
            // field = "prod_-quantity-4" || "prod_-product_id-4"

            let splitTab = field.split("-")
            let name = splitTab[1]
            let index = splitTab[2]
            console.log("[INFO] INDEX field", splitTab, splitTab[0], splitTab[1]);

            let cpProducts = [].concat(this.state.sale.products)
            cpProducts[index][name] = value
            if(name === "quantity") {   
                if(value ==="" || regexINT.test(value)){// update value only if its a int
                let discount = 0;
                let total = 0;
                cpProducts.map( prod => {
                    if ( prod.priceUReal && prod.quantity && prod.priceTotal){
                        let addDiscount = ((prod.priceUReal * prod.quantity ) - prod.priceTotal).toFixed(2)
                        discount += addDiscount > 0 ? addDiscount : 0
                        total += parseFloat(prod.priceTotal)
                    }
                })               
                cpProducts[index].price = Math.round(cpProducts[index].priceTotal / cpProducts[index].quantity) || cpProducts[index].priceUReal
                cpProducts[index].priceU = Math.round(cpProducts[index].price / ( 1 + cpProducts[index].prod_tva_rate / 100))

                    this.setState({
                        ...this.state,
                        sale:{
                            ...this.state.sale,
                            products:cpProducts,
                            discount,
                            total
                        }
                    }, () =>{
                        this.createAddForm()
                    })
                }
                
            } else if(name === "price" || name === "priceTotal") {   
                if(value ==="" || regexFLOAT.test(value)){// update value only if its a int
                let discount = 0;
                let total = 0;
                cpProducts.map( prod => {
                    if ( prod.priceUReal && prod.quantity && prod.priceTotal){
                        let addDiscount = ((prod.priceUReal * prod.quantity ) - prod.priceTotal).toFixed(2)
                        discount += addDiscount > 0 ? addDiscount : 0
                        total += parseFloat(prod.priceTotal)
                    }
                })               
                cpProducts[index].price = (cpProducts[index].priceTotal / cpProducts[index].quantity).toFixed(2) || cpProducts[index].priceUReal
                cpProducts[index].priceU = (cpProducts[index].price / ( 1 + cpProducts[index].prod_tva_rate / 100)).toFixed(2)

                    this.setState({
                        ...this.state,
                        sale:{
                            ...this.state.sale,
                            products:cpProducts,
                            discount,
                            total
                        }
                    }, () =>{
                        this.createAddForm()
                    })
                }
                
            } else {
                this.setState({
                    ...this.state,
                    sale:{
                        ...this.state.sale,
                        products:cpProducts,
                    }
                }, () =>{
                    this.createAddForm()
                })
            }
                    
        } else {
            this.setState({
                ...this.state,
                sale:{
                    ...this.state.sale,
                    [field]:value
                }
            }, () =>{
                this.createAddForm()
            })
        }
    }
    validate = () => {
        let noErrors = true
        let errors = this.state.errors
        const notRequired = ["transport", "taxes", "client_ref", "sale_paygo_id", "total", "discount", "sale_credit","sale_tva"]

        const notRequiredProdItem = ["max", "prod_tva_rate"]
        const valeursNulles = ["", 0, "0"];


        const sale = Object.assign({}, this.state.sale)
        Object.keys(sale).map( field =>{
            console.log(field);
            
            if( isEmpty(sale[field]) && !notRequired.includes(field) ) {// input is empty  
                noErrors = false
                errors[field] = "Veuillez remplir ce champ"
                    
            } else if(field === "products") {
                sale.products.map((item, j) => {
                    Object.keys(item).map( field2 => { // field2 product_id || quantity
                        
                        if(notRequiredProdItem.includes(field2)){
                            errors.products[j][field2] = ""
                        } else if(valeursNulles.includes(item[field2])){
                            noErrors = false
                            errors.products[j][field2] = "Veuillez remplir ce champ valeur nulle" + item[field2]
                            console.log('====================================,',field2,' - ',j);
                            console.log(item[field2]);
                            console.log('====================================');
                        } else if(parseInt(item.max) < parseInt(item.quantity)){
                            noErrors = false
                            errors.products[j].quantity = "Stock insuffisant"
                        } else {
                            errors.products[j][field2] = ""
                        }
                    })
                })

            } else {// not empty
                errors[field] = ""   
            }
        })
                
        console.log("[INFO] NOERRORS = ",noErrors);
        console.log("[INFO] VALIDATE, ERRORS = ",errors);
        
        this.setState({
            ...this.state,
            errors : errors
        })
        if(noErrors){
            this.setState({
                // confirmSubmit:true
                view : "client"
            })
        } else {// !VALIDATE
            toast.error( "Le formulaire contient des erreurs", "Erreur")
        }
        
        // return noErrors
    }

    validateClient = () => {
        let noErrors = true
        let errors = this.state.errorsClient
        const client = Object.assign({}, this.state.client )

        if(!client.client_paygo_id){
            
            const notRequired = ["client_address", "client_email" ,"id"]
            if(this.state.sale.client_ref || this.state.sale.cli_type === "mjb"){ // old client with no phone number
               // notRequired.push("client_tel")
            }
            if(this.state.sale.cli_type !== "mjb"){ // not mjb client so no paygoID
                notRequired.push("client_paygo_id")
            }
            
            Object.keys(client).map( field => {
                if( ( isEmpty(client[field]) && !notRequired.includes(field)) ) { // input is empty  
                    noErrors = false
                    errors[field]="Veuillez remplir ce champ"
                } else {// not empty
                    errors[field]=""   
                }
            })
            console.log("[INFO] NOERRORS = ",noErrors);
            console.log("[INFO] VALIDATE, ERRORS = ",errors);
            
            this.setState({
                ...this.state,
                errorsClient : errors
            })
        }

        if(noErrors){
            this.setState({
                view:"confirm",
                // dialogClient : false
            })
        } else {// !VALIDATE
            toast.error( "Le formulaire contient des erreurs")
        }
        // return noErrors
    }
    
    handleSelectClient = (idClient,infoClient,option) => {
        // console.log("SELECT HANDLE",{option});

        let value = idClient
        let infos = infoClient || {}
        
        this.setState({
            ...this.state,
            client:{
                ...this.state.client,
                clientDisplay:option,
                client_lastname:infos.client_lastname || "",
                client_firstname:infos.client_firstname || "",
                client_address:infos.client_address || "",
                client_tel:infos.client_tel || "",
                client_email:infos.client_email || "",
                client_city:infos.client_city || "",
                client_country:infos.client_country || "",
                client_paygo_id:infos.client_paygo_id || "",
                id: value,
            },
            sale:{
                ...this.state.sale,
                sale_paygo_id: this.state.sale.cli_type === "mjb" ? value : "",
                client_ref: this.state.sale.cli_type !== "mjb" ? value : "",
            }
        })
    }
    handleSelectClientInfo = (idClient,clientInfo) =>{
        console.log("[DEBUG], handleSelectClientInfo",this.state.id ," vs ", idClient)
        if (this.state.client.id  === idClient){
            this.setState({
                ...this.state,
                client:{
                    ...this.state.client,
                    client_address:clientInfo.adress,
                    client_tel:clientInfo.phone,
                }
            })
        }

    }
    handleChangeClient =  (e) => {  
        const field = e.target.name
        const value = e.target.value
        
        this.setState({
            ...this.state,
            client:{
                ...this.state.client,
                [field]:value,
            }
        })
    }
    handleSubmit = async () => {
        // const { sale, client } = this.state;
        this.setState({
            sending: true,
        })
        let sale = Object.assign({}, this.state.sale)
        let client = Object.assign({}, this.state.client)
        // if (!clientRef){
        //     clientRef = await this.createClient()
        //     console.log("REF 2", {clientRef});
        // }
        // if (clientRef){
            sale.unique_id = this.state.uniqueID
            sale.id = ""
            sale.return_id = []
            sale.client = client
            // sale.client_ref = clientRef
            sale.transport = parseFloat(sale.transport)                      
            sale.taxes = parseFloat(sale.taxes) 
            sale.discount = parseFloat(sale.discount) 
            sale.total_price = parseFloat(sale.total)
            for (let i = 0; i < sale.products.length; i++){
                sale.products[i].quantity = parseInt(sale.products[i].quantity)                      
                sale.products[i].price = parseFloat(sale.products[i].priceTotal)     
                sale.products[i].priceU = parseFloat(sale.products[i].priceU)     
                sale.products[i].priceUReal = parseFloat(sale.products[i].priceUReal)     
            }
                
            try{
                const resp = await this.props.createSale(sale)

                //success 
                this.setState({
                    sending: false,
                })
                toast.info("Opération enregistrée avec succès")
                this.clearForms()                        
                this.props.handleClose()
            }catch(err){
                console.log("ERROR", err.message);
                this.setState({
                    sending: false,
                })
                toast.error("[ERROR]"+err.message)
            }
  
    }
    clearForms = () => {
        this.setState({
            numberProd:1,
            
            sale: Object.assign({}, initQuote),
            client: Object.assign({}, initClient),
            // errors?
            errors: Object.assign({}, initErrors),
            errorsClient: Object.assign({}, initClient),                
            
        })
    }

    render() {
        const { view, sale, client } = this.state;
        console.log("[STATE] NEW SALE SALE FORM ", sale);
        // console.log("[PROPS] NEW SALE FORM ",this.props);

        const fieldList = [
            {name: "client_lastname", label: "Nom", display: client.client_lastname},
            {name: "client_firstname", label: "Prénom", display: client.client_firstname},
            {name: "client_address", label: "Adresse", display: client.client_address},
            {name: "client_city", label: "Ville", display: client.client_city},
            {name: "client_country", label: "Pays", display: client.client_country},
            {name: "client_tel", label: "Téléphone", display: client.client_tel},
            {name: "client_email", label: "Email", display: client.client_email},
            {name: "shop_id", label: "Magasin", display: sale.shop_idDisplay.label},
            {name: "comments", label: "Modalités de paiement", display: sale.comments},
            {name: "transport", label: "Coût Transport", display: sale.transport},
            {name: "taxes", label: "Autres Taxes", display: sale.taxes},        
            {name: "products"},   
            {name: "discount", label: "Réduction Totale", display: sale.discount},
            {name: "total", label: "Montant Total", display: sale.total},
        ]
        
        return (
            <React.Fragment>
                {view === "quote" &&
                    <div>
                        <FormQuote 
                            {...this.state} 
                            {...this.props} 
                            handleSelect={this.handleSelect}
                            createAddFormP={this.state.form}//createAddForm}
                            handleAddProd={this.handleAddProd}
                            handleAddProdByCSV={this.handleAddProdByCSV}
                            handleChange={this.handleChange}
                            validate={this.validate}
                            handleCheck={(value, name) => this.setState({
                                ...this.state, 
                                sale: {
                                    ...this.state.sale, 
                                    [name]: value
                                } 
                            })}
                            handleClose={this.props.handleClose}
                        />
                    </div>
                    }
                {view === "client" &&
                    <PopUp 
                        title="Formulaire Client - Devis" 
                        close={() => this.setState({
                            view: "quote", 
                            client:initClient, 
                            client_ref: "",
                            sale_paygo_id: "", 
                        })}
                        submitAction={this.validateClient}
                    >
                        <FormClient 
                            {...this.state} 
                            {...this.props}
                            handleSelectClient={this.handleSelectClient}
                            handleChangeClient={this.handleChangeClient}
                            handleSelectClientInfo={this.handleSelectClientInfo}
                            // validateClient={this.validateClient}
                        />

                    </PopUp>
                    
                }
                {view === "confirm" &&
                <PopUp 
                    title="Résumé" 
                    close={() => this.setState({view: "client"})}
                    submitAction={ this.handleSubmit }
                    submitTitle="Valider" 
                    disabledSubmit={this.props.STATE.sales.fetching || this.state.sending}
                >
                    <TableLayout>
                        <TableBody>
                            <ConfirmFormTemplate
                                transfer={this.state.sale}
                                client={this.state.client}
                                fieldList={fieldList}
                            />
                        </TableBody>
                    </TableLayout>
                </PopUp>
                }
            </React.Fragment>
        );
    }
}

export default Form;